/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload': {
    width: 209,
    height: 209,
    viewBox: '0 0 209 209',
    data: '<path pid="0" d="M135.85 0a72.714 72.714 0 00-67.27 44.448A51.623 51.623 0 0052.25 41.8 52.25 52.25 0 0041.8 145.244v-21.773a31.268 31.268 0 1127.36-55.745A10.447 10.447 0 0085 61.312a52.2 52.2 0 1182.2 53.373v24.456A73.088 73.088 0 00135.85 0zm17.84 128.462L104.5 79.273l-49.19 49.189 14.78 14.776 23.96-23.961V209h20.9v-89.723l23.96 23.961z" fill-rule="evenodd"/>'
  }
})
